<template>
    <v-card
      class="ma-0 pa-3"
      height="411"
    >
        <v-container
            class="pa-0 d-flex justify-space-between align-center mb-4 position-static"
        >
            <div class="d-flex align-center gap-1">
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M20.2501 2.77C20.2522 2.97123 20.1744 3.16508 20.0338 3.30906C19.8932 3.45303 19.7013 3.53536 19.5001 3.538H4.50007C4.29867 3.53536 4.10656 3.45289 3.96593 3.3087C3.8253 3.16451 3.74766 2.9704 3.75007 2.769C3.74766 2.5676 3.8253 2.37349 3.96593 2.2293C4.10656 2.08511 4.29867 2.00264 4.50007 2H19.5001C19.5999 2.0013 19.6984 2.02226 19.7902 2.06166C19.8819 2.10106 19.9649 2.15815 20.0346 2.22965C20.1042 2.30115 20.1591 2.38568 20.1961 2.47839C20.233 2.5711 20.2514 2.67019 20.2501 2.77ZM20.2501 21.23C20.2514 21.3298 20.233 21.4289 20.1961 21.5216C20.1591 21.6143 20.1042 21.6988 20.0346 21.7703C19.9649 21.8419 19.8819 21.8989 19.7902 21.9383C19.6984 21.9777 19.5999 21.9987 19.5001 22H4.50007C4.40026 21.9987 4.30169 21.9777 4.20998 21.9383C4.11827 21.8989 4.03522 21.8419 3.96557 21.7703C3.89593 21.6988 3.84105 21.6143 3.80407 21.5216C3.7671 21.4289 3.74874 21.3298 3.75007 21.23C3.74793 21.0288 3.82569 20.8349 3.96629 20.6909C4.10689 20.547 4.29885 20.4646 4.50007 20.462H19.5001C19.7015 20.4646 19.8936 20.5471 20.0342 20.6913C20.1748 20.8355 20.2525 21.0296 20.2501 21.231" fill="#0066FF"/>
                <path d="M16 5.84375C18.828 5.84375 20.243 5.84375 21.121 6.74475C22 7.64775 22 9.09775 22 11.9977C22 14.8977 22 16.3497 21.121 17.2507C20.243 18.1507 18.828 18.1507 16 18.1507H8C5.172 18.1507 3.757 18.1507 2.879 17.2507C2 16.3497 2 14.8977 2 11.9977C2 9.09775 2 7.64675 2.879 6.74475C3.757 5.84475 5.172 5.84475 8 5.84475L16 5.84375Z" fill="#0066FF"/>
                </svg>
                <v-card-text class="pa-0 text-body-2">{{ $t('unpassedCheck') }}</v-card-text>
            </div>
            <v-btn
              color=""
              outlined
              custom
              @click="goto"
            >
            {{ $t('see-all') }}
            </v-btn>
        </v-container>
        <v-container
          v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')"
          class="pa-0 d-flex justify-space-between align-center"
        >
            <div class="d-flex align-center gap-2">
                <v-btn
                    color=""
                    outlined
                    custom
                    :class="{ 'active': checkType === 'payCheck' }"
                    @click="toggleCheck('payCheck')"
                >
                {{ $t('payCheckList') }}
                </v-btn>
                <v-btn
                    color=""
                    outlined
                    custom
                    :class="{ 'active': checkType === 'recieveCheck' }"
                    @click="toggleCheck('recieveCheck')"
                >
                {{ $t('recieveCheckList') }}
                </v-btn>
            </div>
        </v-container>
        <v-container
          v-if="loading"
          class="pa-0 d-flex align-center justify-center"
        >
          <v-progress-circular
            :width="3"
            color="blue"
            indeterminate
          />
        </v-container>
        <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
          <v-list
              v-if="items != null && items != undefined && items.length > 0"
              class="pa-0 mt-5"
          >
              <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  class="pa-0"
              >
                  <v-list-item-content class="pa-0">
                      <v-container class="pa-0 d-flex justify-space-between align-center">
                          <div style="width: 140px;">
                              <v-card-text class="pa-0 text-body-2">{{ item.account ? item.account.name : '' }}</v-card-text>
                              <v-card-text class="pa-0 text-caption text--disabled">{{ item.number ? '#' + item.number : '' }}</v-card-text>
                          </div>
                          <div>
                              <v-card-text class="pa-0 text-body-2">{{ item.due_date ? item.due_date : '' }}</v-card-text>
                              <v-card-text class="pa-0 text-caption text--disabled">
                                  {{ resolveRemainDays(item) }}
                              </v-card-text>
                          </div>
                          <div style="width: 110px;text-align: left;">
                              <v-card-text class="pa-0 text-body-2">
                                  {{ $numberFormat(item.amount) }} {{ $store.state.currency.name }}
                              </v-card-text>
                          </div>
                      </v-container>
                      <v-divider class="my-1" />
                  </v-list-item-content>
              </v-list-item>
          </v-list>
          <div
            v-if="items != null && items != undefined && items.length == 0 && !loading"
            style="margin-top: 70px;margin-bottom: 95px;"
          >
            <div class="d-flex justify-center align-center">
              <img src="@/assets/dashboard/no-data(3).png" style="width: 150px;height: 60px;" />
            </div>
            <div class="d-flex justify-center align-center mt-5">
              <v-card-text class="pa-0 text-caption text-center">
                {{ $t('there is no enough information for showing.') }}
              </v-card-text>
            </div>
          </div>
          <v-container
            v-if="!loading"
            class="px-0 py-3 d-flex justify-space-between align-center"
          >
              <v-card-text
                  class="pa-0 text-body-2 d-flex align-center gap-1"
              >
                  <p class="mb-0">{{ $t('page-total') }}</p>
                  <p class="mb-0">{{ $store.state.currency.name }}</p>
                  <p class="mb-0">{{ $numberFormat(sumOfChecks) }}</p>
              </v-card-text>
              <v-card-text class="pa-0 text-body-2 d-flex align-center gap-1">
                  <p class="mb-0">{{ displayedRange }}</p>
                  <p class="mb-0">{{ $t('per-person') }} {{ $t('from') }}</p>
                  <p class="mb-0">{{ total }}</p>
              </v-card-text>
              <div class="d-flex align-center gap-2">
                  <v-btn
                      custom
                      color="secondary"
                      outlined
                      @click="prevPage"
                      :disabled="isPrevDisabled"
                  >
                  <v-icon>{{ $vuetify.rtl ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
                  </v-btn>
                  <v-btn
                      custom
                      color="secondary"
                      outlined
                      @click="nextPage"
                      :disabled="isNextDisabled"
                  >
                  <v-icon>{{ $vuetify.rtl ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
                  </v-btn>
              </div>
          </v-container>
        </div>
        <div v-else>
          <div
            style="margin-top: 70px;"
          >
            <div class="d-flex justify-center align-center">
              <img src="@/assets/dashboard/not-access(2).png" style="width: 150px;height: 60px;" />
            </div>
            <div class="d-flex justify-center align-center mt-5">
              <v-card-text class="pa-0 text-caption text-center">
                {{ $t("you don't have access to this information") }}
              </v-card-text>
            </div>
          </div>
        </div>
    </v-card>
</template>

<script>
import moment from 'moment-jalaali'

export default {
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: []
      },
      items: [],
      loading: false,
      lastPage: null,
      checkType: 'payCheck',
      status: 'issued',
      isNextDisabled: false,
      isPrevDisabled: false,
      total: null,
      sumOfChecks: null
    }
  },
  computed: {
    displayedRange () {
      const start = (this.options.page - 1) * this.options.itemsPerPage + 1
      const end = Math.min(this.options.page * this.options.itemsPerPage, this.total)
      return `${start} - ${end}`
    }
  },
  methods: {
    fetchList () {
      if (this.items.length == 0) {
        this.loading = true
      }
      this.$axios.get(this.$endpoint + 'checks', {
        params: {
          page: this.options.page,
          options: JSON.stringify({ page: this.options.page, itemsPerPage: this.options.itemsPerPage }),
          type: this.checkType,
          status: [this.status]
        }
      })
        .then(r => {
          this.loading = false
          this.items = r.data.data
          this.lastPage = r.data.last_page
          this.total = r.data.total
          this.isPrevDisabled = this.options.page === 1
          this.isNextDisabled = this.options.page === this.lastPage
          this.sumOfChecks = this.items.reduce((sum, item) => sum + parseFloat(item.amount), 0)
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    resolveRemainDays (item) {
      const today = moment().startOf('day') // Get today's Jalali date
      const due = moment(item.due_date, 'jYYYY/jMM/jDD') // Convert due_date from Jalali to moment

      const diffDays = due.diff(today, 'days') // Get the difference in days

      return diffDays > 0 ? `${diffDays} ${this.$t('days-left')}` : 'پایان مهلت'
    },
    toggleCheck (value) {
      this.options.page = 1
      this.checkType = value
      if (value == 'payCheck') {
        this.status = 'issued'
      }
      if (value == 'recieveCheck') {
        this.status = 'fund'
      }
      this.fetchList()
    },
    nextPage () {
      if (this.options.page < this.lastPage) {
        this.options.page++
        this.fetchList()
      }
    },
    prevPage () {
      if (this.options.page > 1) {
        this.options.page--
        this.fetchList()
      }
    },
    goto () {
      this.$router.push('/check/recieve/list')
    }
  },
  mounted () {
    this.fetchList()
  },
  watch: {
    'options.page': function (newPage) {
      this.isPrevDisabled = newPage === 1 // Disable Prev when on first page
      this.isNextDisabled = newPage === this.lastPage // Disable Next when on last page
    },
    lastPage (newVal) {
    // If the last page changes, recheck whether Next should be disabled
      this.isNextDisabled = this.options.page === newVal
    }
  }
}
</script>

<style scoped>
.v-btn--outlined {
    border: thin solid #c0c0c09e;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
.v-list {
    height: 244px;
    overflow: auto;
}
.v-list::-webkit-scrollbar {
  display: none;
}
.active {
    background-color: #c0c0c09e;
}
</style>
